import React, { Fragment, memo, useState, useEffect, useRef } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { faReply, faSave } from '@fortawesome/free-solid-svg-icons';
import { SiteRutas } from '../../request/RutasConfig.jsx';
import EtiquetasReportesInt from './etiquetasReportesInt.jsx';
import { Notificacion } from '../../components/Util/Notificacion/Notificacion.jsx';
//Invocaciones datos
import { ParametroGenerales_Consulta_Request, ParametrosGenerales_GuardarAct_Request } from '../../request/ServicioRequest.jsx';
import { useSessionStorage } from '../../components/Util/Hooks/useSessionStorage.jsx';
import ModalSpinner from '../../components/UI/modalSpinner/modalSpinner.jsx';

//Seguridad
import Config from '../../components/Util/constantes.js';
import { Obtener_MenuOpciones_Lista_Request, Obtener_MenuNombre_Request } from "../../request/MenuRequest.jsx"
import ModalSeguridad from "../Seguridad/ModalSeguridad.jsx";
import optSeg from '../../components/Util/seg-menu-opciones.js';

import moment from 'moment/moment.js';

export function etiquetasReportes() {
    const [token, setToken] = useSessionStorage('tokenCON', '');
    const [usuario, setUsuario] = useSessionStorage('usuarioCON');
    const mounted = useRef();
    const [spinnerModal, setSpinnerModal] = useState(undefined);
    const [spinnerLabel, setSpinnerLabel] = useState('');
    const [spinnerTipo, setSpinnerTipo] = useState(1);
    let historyMenu = useHistory();

    const listaCampos = {
        IngresosNoDeducibles: { value: "", attributes: { readOnly: false, ID: '', focus: false, label: 'Ingresos No Deducibles:', hidden: 'unset', Editando: false, maxLength: "100" } },
        EgresosNoDeducibles: { value: "", attributes: { readOnly: false, ID: '', focus: false, label: 'Egresos No Deducibles:', hidden: 'unset', Editando: false, maxLength: "100" } },
    }

    const botones = [
        {
            name: "btnHomeC",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => volverAtras(),
            leyenda: "",
            iclase: faReply,
            tooltip: "Volver"
        },
        {
            name: "btnGuardar",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => handleAceptar(),
            leyenda: "",
            iclase: faSave,
            tooltip: "Guardar"
        }
    ];

    const jsonEtiquetas =
    {
        'Ingresos': [], 'Egresos': []
    };

    //Seguridad
    const [usuarioS, setUsuarioS] = useSessionStorage('UsuarioSCON');
    const [menuId, setMenuId] = useState(0);
    const [menuOpciones, setMenuOpciones] = useState([]);
    const [showModalSeguridad, setShowModalSeguridad] = useState(false);
    const [opcionValidar, setOpcionValidar] = useState(0);
    const [opcionValidarNombre, setOpcionValidarNombre] = useState('');
    const Label_Egresos = 'Etiqueta_EgresosNoDeducibles';
    const Label_Ingresos = 'Etiqueta_IngresosNoDeducibles';

    const [datos, setDatos] = useState(listaCampos);
    const [listaDatosM, setListadatosM] = useState(listaDatosM);

    const spinnerModalMostrar = (pSpinnerModal, pSpinnerLabel, pSpinnerTipo) => {
        setSpinnerModal(pSpinnerModal);
        setSpinnerLabel(pSpinnerLabel);
        setSpinnerTipo(pSpinnerTipo);
    };

    const CargaEtiquetas = async () => {

        let etiquetaIngresos = await ParametroGenerales_Consulta_Request(token, Label_Ingresos);
        let etiquetaEgresos = await ParametroGenerales_Consulta_Request(token, Label_Egresos);

        if (etiquetaIngresos.Exitoso && etiquetaEgresos.Exitoso) {

            jsonEtiquetas.Egresos.push(etiquetaEgresos.Datos);
            jsonEtiquetas.Ingresos.push(etiquetaIngresos.Datos);

            setListadatosM(jsonEtiquetas);

            if (etiquetaEgresos.Datos.Parametro_Valor !== "") {
                listaCampos.EgresosNoDeducibles.value = etiquetaEgresos.Datos.Parametro_Valor;
            } else {
                listaCampos.EgresosNoDeducibles.value = "Egresos No Deducibles";
            }

            if (etiquetaIngresos.Datos.Parametro_Valor !== "") {
                listaCampos.IngresosNoDeducibles.value = etiquetaIngresos.Datos.Parametro_Valor;
            } else {
                listaCampos.IngresosNoDeducibles.value = "Otros Ingresos";
            }

            listaCampos.EgresosNoDeducibles.attributes.ID = etiquetaEgresos.Datos.Parametro_Nombre;
            listaCampos.IngresosNoDeducibles.attributes.ID = etiquetaIngresos.Datos.Parametro_Nombre;

            return true;

        } else {
            Notificacion.error("Sucedió un error al consultar las etiquetas de reporte.");
            return false;
        }

    };

    const volverAtras = () => {
        historyMenu.push(SiteRutas.Asientos);
    };

    const handleAceptar = async () => {

        if (validarDatos()) {
            const optSegopt = optSeg.TOpciones_Menu;
            const _value = optSegopt.Guardar.value;

            let validar = validarMenuOpcion(_value);

            if (!validar) {
                await ParametrosGenerales_GuardarAct();
            }
        }
    };

    const validarDatos = () => {

        if (datos.IngresosNoDeducibles.value.trim().length === 0) {
            Notificacion.error("Error: Debe ingresar el dato: Ingresos No Deducibles.");
            return false;
        }

        if (datos.EgresosNoDeducibles.value.trim().length === 0) {
            Notificacion.error("Error: Debe ingresar el dato: Egresos No Deducibles.");
            return false;
        }

        return true;
    };

    const cargarDatos = async () => {
        let spinnerLabel = 'Cargando datos...';
        spinnerModalMostrar(true, spinnerLabel, 3)

        let etiquetas = await CargaEtiquetas();

        if (!etiquetas) {
            return;
        }

        const _MenuNomb = await cargarMenuNombre(Config.Modulo, optSeg.TMenuSistema.EtiquetasdeReportes.value);

        let _menuId = 0
        if (_MenuNomb.ID != undefined) {
            _menuId = _MenuNomb.ID;
        }
        const _UsuarioS = usuarioS;
        let _menuOpciones = null;
        if (_menuId > 0) {
            _menuOpciones = await cargarMenuOpciones(Config.Modulo, _UsuarioS, _menuId);
        }

        setMenuId(_menuId), setMenuOpciones(_menuOpciones)
        spinnerModalMostrar(false, '', 3)
    };

    useEffect(() => {

        if (!mounted.current) {
            const carga = async () => {
                await cargarDatos()
            }
            carga();
            mounted.current = true;
        }
    }, []);

    //Seguridad
    const cargarMenuOpciones = async (pModuloId, pUsuarioId, pMenuId) => {
        try {

            let listMO = await Obtener_MenuOpciones_Lista_Request(token, pModuloId, pUsuarioId, pMenuId);
            if (listMO.Exitoso === false) {
                return null;
            }
            return listMO.Datos;
        }
        catch (err) {
            Notificacion.error(`Error: cargarMenuOpciones.`);
        }
    };

    const cargarMenuNombre = async (pModulo, pMenuNombre) => {
        try {
            let listMON = await Obtener_MenuNombre_Request(token, pModulo, pMenuNombre);
            if (listMON.Exitoso == false) {
                return null;
            }
            return listMON.Datos;
        }
        catch (err) {
            Notificacion.error(`Error: cargarMenuNombre.`);
        }
    };

    const validarMenuOpcion = (pOpcion) => {
        let validar = false;
        let _menuOpciones = menuOpciones;
        const optSegopt = optSeg.TOpciones_Menu;
        let resultado = _menuOpciones.filter((item) => item.Opcion_Nombre == pOpcion);
        if (resultado.length > 0) {
            if (resultado[0].Opcion_Validar) {
                setShowModalSeguridad(true); setOpcionValidar(resultado[0].Opcion_Id); setOpcionValidarNombre(pOpcion);
                validar = true;
            }
        } else {
            setShowModalSeguridad(true); setOpcionValidar(resultado[0].Opcion_Id); setOpcionValidarNombre(pOpcion);
            validar = true;
        }
        return validar;
    };

    const handleCerrarModal = () => setShowModalSeguridad(false);

    const onActionResultModal = (pValido) => {
        if (pValido) {
            let _OpcionNom = opcionValidarNombre;
            setShowModalSeguridad(false); setOpcionValidar(0); setOpcionValidarNombre('');
            const _optSegopt = optSeg.TOpciones_Menu;
            switch (_OpcionNom) {
                case _optSegopt.Guardar.value:
                    ParametrosGenerales_GuardarAct();
                    break;
                default:
                    break;
            }
        }
    };

    const ParametrosGenerales_GuardarAct = async () => {

        let spinnerLabel = 'Cargando datos...';
        spinnerModalMostrar(true, spinnerLabel, 3)

        const _datosList = await llenarListaDatos();

        let resultado = await ParametrosGenerales_GuardarAct_Request(token, JSON.stringify(..._datosList.Ingresos));
        let resultado2 = await ParametrosGenerales_GuardarAct_Request(token, JSON.stringify(..._datosList.Egresos));

        if (resultado.Exitoso && resultado2.Exitoso) {
            Notificacion.success("Se actualizó con éxito.");
        } else {
            Notificacion.error("Sucedió un error al actualizar los datos.")
        }

        spinnerModalMostrar(false, '', 3)
    };

    const llenarListaDatos = async () => {

        let _Datos = listaDatosM;

        _Datos.Ingresos[0].Parametro_Valor = datos.IngresosNoDeducibles.value;
        _Datos.Ingresos[0].Usuario_Modifica = usuario;
        _Datos.Ingresos[0].Parametro_Nombre = datos.IngresosNoDeducibles.attributes.ID;
        _Datos.Ingresos[0].Usuario_Fecha_Actualiza = (moment().format("yyyy-MM-DD hh:mm:ss.SSS")).toString();;

        _Datos.Egresos[0].Parametro_Valor = datos.EgresosNoDeducibles.value;
        _Datos.Egresos[0].Usuario_Modifica = usuario;
        _Datos.Egresos[0].Parametro_Nombre = datos.EgresosNoDeducibles.attributes.ID;
        _Datos.Egresos[0].Usuario_Fecha_Actualiza = (moment().format("yyyy-MM-DD hh:mm:ss.SSS")).toString();;

        return _Datos;
    };

    const onChangeInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        let newAttributes = datos[name].attributes;
        //newAttributes.focus = true; //Se asigna foco al componente
        const Datos = Object.assign({}, datos, { [name]: { value: value, attributes: newAttributes } })
        setDatos(Datos);
    };

    return (
        <Fragment>

            <EtiquetasReportesInt
                titulo={'Etiquetas Tipos de Cuenta'}
                botones={botones}
                Datos={datos}
                onChangeInput={onChangeInput}
            />

            <ModalSpinner
                selectedModal={spinnerModal}
                contentLabel={'spinnerModalProgress'}
                label={spinnerLabel}
                tipoSpinner={spinnerTipo}
            />

            <ModalSeguridad
                modalTitle={'Requiere Permisos'}
                menuId={menuId}
                opcionId={opcionValidar}
                show={showModalSeguridad}
                onActionResult={onActionResultModal}
                onHide={handleCerrarModal}
            />

        </Fragment>
    );
};

export default withRouter(memo(etiquetasReportes));